import React, { createContext, useEffect, useState } from 'react';
import { auth } from '../services/firebase';
import { createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut, signInWithPopup, sendPasswordResetEmail, updatePassword } from 'firebase/auth';

export const IdentityContext = createContext();

const IdentityProvider = (props) => {
    const { children } = props;
    const [authUser, setAuthUser] = useState(null);
    const [token, setToken] = useState(null);
    const [hasClaims, setHasClaims] = useState(null);
    const [accountId, setAccountId] = useState(null);
    const [userId, setUserId] = useState(null);
    const [isIdentified, setIsIdentified] = useState(false);

    useEffect(() => {
        auth.onAuthStateChanged(async authUser => {
            // console.log('got authuser', authUser);
            setAuthUser(authUser);
            if (authUser) {
                const idToken = await authUser.getIdToken(); 
                try {
                    const tokenResult = await authUser.getIdTokenResult();
                    // console.log('got tokenResult', tokenResult);
                    const { claims } = tokenResult;
                    setAccountId(claims['https://hasura.io/jwt/claims']['x-hasura-org-id']);
                    setUserId(claims['https://hasura.io/jwt/claims']['x-hasura-user-id']);
                    setToken(idToken);
                    setHasClaims(true);
                } catch {
                    setAccountId(null);
                    setUserId(null);
                    setToken(idToken);
                    setHasClaims(false);
                }
            } else {
                setToken(null);
                setHasClaims(null);
            }
        });
    }, []);

    useEffect(() => {
        setIsIdentified(accountId && userId);
    }, [accountId, userId])

    const doCreateUserWithEmailAndPassword = (email, password) => createUserWithEmailAndPassword(auth, email, password);
    const doSignInWithEmailAndPassword = (email, password) => signInWithEmailAndPassword(auth, email, password);
    const doSignOut = () => signOut(auth);
    const doSignInWithPopup = (provider) => signInWithPopup(auth, provider);
    const doPasswordReset = email => sendPasswordResetEmail(auth, email);
    const doPasswordUpdate = password => updatePassword(authUser, password);
    const refreshIdToken = async () => {
        // console.log('refreshing')
        if (authUser) {
            const newToken = await authUser.getIdToken(true);
            setToken(newToken);
            try {
                const tokenResult = await authUser.getIdTokenResult();
                // console.log('got tokenResult', tokenResult);
                const { claims } = tokenResult;
                setAccountId(claims['https://hasura.io/jwt/claims']['x-hasura-org-id']);
                setUserId(claims['https://hasura.io/jwt/claims']['x-hasura-user-id']);
                setHasClaims(true);
            } catch {
                setAccountId(null);
                setUserId(null);
                setHasClaims(false);
            }
        } else {
            doSignOut()
        }
    };

    return (
        <IdentityContext.Provider value={{
            authUser,
            token,
            accountId,
            userId,
            isIdentified,
            hasClaims,
            doCreateUserWithEmailAndPassword,
            doSignInWithEmailAndPassword,
            doSignOut,
            doSignInWithPopup,
            doPasswordReset,
            doPasswordUpdate,
            refreshIdToken,
        }}>
            {children}
        </IdentityContext.Provider>
    )
}

export default IdentityProvider;

